import PlatformSnippet from './PlatformSnippet';

export default PlatformSnippet;
